<template>
  <div class="bzscbb-container" v-loading.fullscreen.lock="fullscreenLoading">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="车间">
              <el-select v-model="searchForm.factory" style="width: 120px" @keyup.enter.native="getData" filterable clearable>
                <el-option v-for="item in factoryList" v-if="item.brand===0||group.dBrand===0||group.dBrand===item.brand" :key="item.factory_id" :label="item.simple_name"  :value="item.factory_id" />
              </el-select>
            </el-form-item>
            <el-form-item label="包装日期">
              <el-date-picker
                v-model="searchForm.time"
                format="yyyy年MM月dd日"
                value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button @click="getData" icon="el-icon-search">搜索</el-button>
              <el-button icon="el-icon-printer" @click="print">打印报表</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content" v-loading="loading">
            <table class="tcf-bb-table">
              <thead>
                <tr>
                  <th>序号</th>
                  <th>订单号</th>
                  <th>生产单号</th>
                  <th>生产车间</th>
                  <th>经销商</th>
                  <th>客户地址</th>
                  <th>金额</th>
                  <th>包装完成日期</th>
                  <th>包装件数</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(t,index) in tableData">
                  <td>{{index+1}}</td>
                  <td>{{t.ordernum}}</td>
                  <td>{{t.produnum}}</td>
                  <td>{{t.abbname}}</td>
                  <td>{{t.delname}}</td>
                  <td>{{t.address}}</td>
                  <td>{{t.prductionAmont}}</td>
                  <td>{{t.packtime}}</td>
                  <td>{{t.packcount}}</td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>{{totalamount}}</td>
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getErpPackFinishReport, getFactoryList, getGroupInfoByUser } from '@/api/erp'
import { getLodop } from '@/common/Lodop/LodopFuncs'

export default {
  name: 'bzwcbb',
  computed: {
    user: getUser
  },
  data() {
    return {
      fullscreenLoading: false,
      loading: false,
      searchForm: {
        time: [],
        factory: ''
      },
      data: '',
      completionAmount: '',
      workAmount: '',
      woedAmount: '',
      tableData: [],
      totalamount: 0,
      factoryList: [],
      group: {
        dBrand: 1
      }
    }
  },
  created() {
    getGroupInfoByUser({ groupid: this.user.dGroupid }).then(response => {
      this.group = response.data
    })
    getFactoryList().then(response => {
      this.factoryList = response.data
    })
    const myDate = new Date()
    const year = myDate.getFullYear()
    let month = myDate.getMonth() + 1
    let day = myDate.getDate()
    month = month > 9 ? month + '' : '0' + month
    day = day > 9 ? day + '' : '0' + day
    this.searchForm.time.push(year + '-' + month + '-01')
    this.searchForm.time.push(year + '-' + month + '-' + day)
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      this.totalamount = 0
      let starttime = ''
      let endtime = ''
      if (this.searchForm.time.length > 0) {
        starttime = this.searchForm.time[0]
        endtime = this.searchForm.time[1]
      }
      const data = {
        starttime: starttime,
        endtime: endtime,
        groupid: this.user.dGroupid,
        userid: this.user.dUserid,
        role: this.user.role,
        factory: this.searchForm.factory
      }
      getErpPackFinishReport(data).then(response => {
        const lst = response.data.lst
        this.tableData = lst
        const totalamount = response.data.totalamount
        this.totalamount = totalamount
        let html = ''
        for (let i = 0; i < lst.length; i++) {
          const xh = i + 1
          html += '<tr style="text-align:center;border-collapse:collapse;border:1px solid black;height:8mm;font-size:16pt;word-break: keep-all;white-space:nowrap;">'+
            '<td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 0;">'+xh+'</td>'+
            '<td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 0;">'+lst[i].ordernum+'</td>'+
            '<td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 0;">'+lst[i].produnum+'</td>'+
            '<td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 0;">'+lst[i].delname+'</td>'+
            '<td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 0;">'+lst[i].address+'</td>'+
            '<td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 0;">'+lst[i].prductionAmont+'</td>'+
            '<td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 0;">'+lst[i].packtime+'</td>'+
            '<td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 0;">'+lst[i].packcount+'</td>'+
            '</tr>'
        }
        html += '<tr style="text-align:center;border-collapse:collapse;border:1px solid black;height:8mm;font-size:16pt;word-break: keep-all;white-space:nowrap;">'+
          '<td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 0;"></td>'+
          '<td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 0;"></td>'+
          '<td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 0;"></td>'+
          '<td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 0;"></td>'+
          '<td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 0;"></td>'+
          '<td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 0;">'+totalamount+'</td>'+
          '<td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 0;"></td>'+
          '<td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 0;"></td>'+
          '</tr>'
        html += '</tbody>\n' +
          '    \t\t\t\t<tfoot>\n' +
          '    \t\t\t\t<tr>\n' +
          '    \t\t\t\t\t<TD colspan="15"  style="text-align: right;font-size:12pt;padding-top: 3mm;">\n' +
          '    \t\t\t\t\t\t第&nbsp;<span tdata="pageNO" format="#">#</span>&nbsp;/&nbsp;<span tdata="pageCount" format="#">#</span>&nbsp;页\n' +
          '    \t\t\t\t\t</TD>\n' +
          '    \t\t\t\t</tr>\n' +
          '    \t\t\t\t</tfoot>\n' +
          '    \t\t\t</table>'
        html = '<table style="border-collapse: collapse;page-break-before:always;font-family:宋体;width: 100%;">\n' +
          '    \t\t\t\t<thead>\n' +
          '    \t\t\t\t\t<tr>\n' +
          '\t    \t\t\t\t\t<td colspan="15" style="font-size:30pt;text-align:center;line-height:60px;font-weight: bold;" id="title" >\n' +
          '\t    \t\t\t\t\t\t<span>包装车间生产完成报表</span>\n' +
          '\t    \t\t\t\t\t</td>\n' +
          '    \t\t\t\t\t</tr>\n' +
          '    \t\t\t\t\t<tr style="text-align:center;border-collapse:collapse;border:1px solid black;height:8mm;font-size:16pt;word-break: keep-all;white-space:nowrap;">\n' +
          '\t\t\t\t\t\t\t<td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 2mm;"></td>\n' +
          '\t\t\t\t\t\t\t<td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 0;"></td>\n' +
          '\t\t\t\t\t\t\t<td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 0;"></td>\n' +
          '\t\t\t\t\t\t\t<td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 0;"></td>\n' +
          '\t\t\t\t\t\t\t<td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 0;"></td>\n' +
          '\t\t\t\t\t\t\t<td id="totalAmount" style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 0;">总金额:'+totalamount+'</td>\n' +
          '\t\t\t\t\t\t\t<td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 2mm;"></td>\n' +
          '\t\t\t\t\t\t\t<td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 0;"></td>\n' +
          '    \t\t\t\t\t</tr>\n' +
          '    \t\t\t\t\t<tr style="text-align:center;border-collapse:collapse;border:1px solid black;height:8mm;font-size:16pt;word-break: keep-all;white-space:nowrap;">\n' +
          '\t\t\t\t\t\t\t<td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 2mm;">序号</td>\n' +
          '\t\t\t\t\t\t\t<td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 0;">订单号</td>\n' +
          '\t\t\t\t\t\t\t<td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 0;">生产单号</td>\n' +
          '\t\t\t\t\t\t\t<td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 0;">经销商</td>\n' +
          '\t\t\t\t\t\t\t<td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 0;">客户地址</td>\n' +
          '\t\t\t\t\t\t\t<td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 0;">金额</td>\n' +
          '\t\t\t\t\t\t\t<td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 2mm;">包装完成日期</td>\n' +
          '\t\t\t\t\t\t\t<td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 0;">包装件数</td>\n' +
          '    \t\t\t\t\t</tr>\n' +
          '    \t\t\t\t</thead>\n' +
          '    \t\t\t\t<tbody>' + html
        this.data = html
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    print() {
      const LODOP = getLodop()
      if (LODOP !== null && LODOP !== undefined) {
        LODOP.PRINT_INIT('包装生产完成报表打印')
        LODOP.SET_PRINT_PAGESIZE(1, 0, 0, 'A4')
        LODOP.SET_PRINT_MODE('PRINT_PAGE_PERCENT', 'Auto-Width')
        LODOP.ADD_PRINT_TABLE(30, '11mm', '100%', '100%', this.data)
        LODOP.SET_PRINT_STYLEA(0, 'HOrient', 3)
        LODOP.SET_PRINT_STYLEA(0, 'VOrient', 3)
        LODOP.SET_SHOW_MODE('LANDSCAPE_DEFROTATED', 1)
        LODOP.NewPageA()
        LODOP.SET_PRINT_STYLEA(0, 'HtmWaitMilSecs', 100)
        LODOP.PREVIEW()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .tcf-bb-table{
    width: 100%;
    background-color: #fff;
    border-collapse: collapse;
    border-spacing: 0;
    font-size: 13px;
    text-align: center;
    margin-top: 20px;
    thead{
      color: #909399;
      font-weight: 500;
      tr{
        th{
          border: 1px solid #EBEEF5;
          background: #f6f8fa;
          color: #303133;
          padding: 12px 0;
        }
      }
    }
    tbody{
      tr{
        td{
          border: 1px solid #EBEEF5;
          color: #303133;
          padding: 12px 0;
        }
        &:hover{
          background: #f3f6f9;
        }
      }
    }
  }
</style>
